module.exports = __webpack_public_path__ + "img/制御工学5_7_1.f1f632aa.png";